import { createSlice } from "@reduxjs/toolkit";
import { FEATURE_FLOW_SLICE_NAME } from "../sliceConstants";
import extraReducers from "./thunk/featureExtraReducers";
import featureThunkActions from "./thunk/featureThunk";

const initialState = {
  allowedIds: {
    isLoading: false,
    data: [],
    error: null,
    // true once fetch-access has resolved or failed; the router holds page
    // rendering until then so first-load APIs carry the HO filter.
    settled: false,
  },
  // Org context from the access-management response (single value today,
  // possibly a list in future). Normalized to [{ value, name }].
  businesses: [],
  categories: [],
};

export const featureFlowSlice = createSlice({
  name: FEATURE_FLOW_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers,
});

export const featureActions = {
  ...featureFlowSlice.actions,
  ...featureThunkActions,
};

export default featureFlowSlice.reducer;
